import { IconProps } from "typing";
import { theme } from "../themes";

export const MyOrdersIcon = ({
  width = "20",
  height = "20",
  color = theme.colors.neutral["999"],
  testId = "my-orders-icon",
}: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      data-testid={testId}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.4392 13.3329V6.6679C17.4392 6.07207 17.1217 5.52207 16.6058 5.22457L10.8342 1.89207C10.3183 1.59457 9.68333 1.59457 9.1675 1.89207L3.39583 5.22457C2.88 5.52207 2.5625 6.0729 2.5625 6.6679V13.3321C2.5625 13.9279 2.88 14.4779 3.39583 14.7754L9.1675 18.1087C9.68333 18.4062 10.3183 18.4062 10.8342 18.1087L16.6058 14.7762C17.1217 14.4787 17.4392 13.9279 17.4392 13.3329Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.14258 10.5254L7.64258 11.9754"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.78516 5.83398L10.0002 9.99982L17.2152 5.83398"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0007 18.3333V10"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.39258 7.91667L13.8342 3.625"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
